<template>
    <div :class="`${getClassName('wrapper')} autocomplete-wrapper`" style="position: relative;">
        <input
            style="margin-bottom: 0"
            ref="input"
            type="text"
            :id="id"
            :class="`${getClassName('input')} autocomplete-input`"
            :placeholder="placeholder"
            :disabled="disabled"
            :required="required"
            :name="name"
            v-model="type"
            @input="handleInput"
            @click="handleClick"
            @dblclick="handleDoubleClick"
            @blur="handleBlur"
            @keydown="handleKeyDown"
            @focus="handleFocus"
            @paste="handlePaste"
            autocomplete="off"
        />
        <div v-if="listActive && !json.length && type"
             style="background: #f4f4f4; padding: 2px 5px; position: absolute; z-index: 10000; width: 100%">
            К сожалению, по вашему запросу ничего не найдено
        </div>
        <div
            :class="`${getClassName('list')} autocomplete autocomplete-list`"
            style="position: absolute; z-index: 10000; width: 100%;"
            v-show="listActive && json.length"
        >
            <ul>
                <li
                    v-for="(data, i) in json"
                    :class="activeClass(i)"
                >
                    <a
                        href="#"
                        @click.prevent="selectList(data)"
                        @mousemove="mousemove(i)"
                        v-if="onShouldRenderChild" v-html="onShouldRenderChild(data)"
                    >
                        <div v-if="!onShouldRenderChild">
                            <b class="autocomplete-anchor-text">{{ deepValue(data, anchor) }}</b>
                            <span class="autocomplete-anchor-label">{{ deepValue(data, label) }}</span>
                        </div>
                    </a>
                </li>
            </ul>

        </div>

    </div>
</template>


<script>

/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
* Licensed Under MIT (http://opensource.org/licenses/MIT)
*
* Vue 2 Autocomplete @ Version 0.0.1
*
*/

export default {

    props: {
        id: String,
        name: String,
        className: String,
        classes: {
            type: Object,
            default: () => ({
                wrapper: false,
                input: false,
                list: false,
                item: false,
            })
        },
        placeholder: String,
        required: Boolean,
        disabled: {
            type: Boolean,
            default: false,
        },

        // Intial Value
        initValue: {
            type: String,
            default: ""
        },

        // Manual List
        options: Array,

        // Filter After Get the data
        filterByAnchor: {
            type: Boolean,
            default: true,
        },

        // Anchor of list
        anchor: {
            type: String,
            required: true
        },

        // Label of list
        label: String,

        // Debounce time
        debounce: Number,

        // query param
        param: {
            type: String,
            default: 'q'
        },

        encodeParams: {
            type: Boolean,
            default: true,
        },

        // Custom Params
        customParams: Object,

        // Custom Headers
        customHeaders: Object,

        // minimum length
        min: {
            type: Number,
            default: 0
        },

        // Create a custom template from data.
        onShouldRenderChild: Function,

        // Process the result before retrieveng the result array.
        process: Function,

        // Callback
        onInput: Function,
        onShow: Function,
        onBlur: Function,
        onHide: Function,
        onFocus: Function,
        onPaste: Function,
        onSelect: Function,
        onBeforeAjax: Function,
        onAjaxProgress: Function,
        onAjaxLoaded: Function,
        makeRequest: Function,
    },

    data() {
        return {
            listActive: false,
            type: "",
            json: [],
            focusList: "",
            debounceTask: undefined,
        };
    },

    watch: {
        options(newVal, oldVal) {
            if (this.filterByAnchor) {
                const { type, anchor } = this
                const regex = new RegExp(`${type}`, 'i')
                const filtered = newVal.filter((item) => {
                    const found = item[anchor].search(regex) !== -1
                    return found
                })
                this.json = filtered
            } else {
                this.json = newVal
            }
        }
    },

    methods: {

        getClassName(part) {
            const { classes, className } = this
            if (classes[part]) return `${classes[part]}`
            return className ? `${className}-${part}` : ''
        },

        clearInput() {
            this.hideList();
            this.type = ""
            this.json = []
            this.focusList = ""
        },

        cleanUp(data){
            return JSON.parse(JSON.stringify(data));
        },


        /*==============================
          INPUT EVENTS
        =============================*/
        handleInput(e){
            const { value } = e.target
            this.showList()
            // Callback Event
            if(this.onInput) this.onInput(value)
            // If Debounce
            if (this.debounce) {
                if (this.debounceTask !== undefined) clearTimeout(this.debounceTask)
                this.debounceTask = setTimeout(() => {
                    return this.getData(value)
                }, this.debounce)
            } else {
                return this.getData(value)
            }
        },


        handleKeyDown(e){
            let key = e.keyCode;

            // Disable when list isn't showing up
            if(!this.listActive) return;

            // Key List
            const DOWN = 40
            const UP = 38
            const ENTER = 13
            const ESC = 27


            // Prevent Default for Prevent Cursor Move & Form Submit
            switch (key) {
                case DOWN:
                    e.preventDefault()
                    this.focusList++;
                    break;
                case UP:
                    e.preventDefault()
                    this.focusList--;
                    break;
                case ENTER:
                    e.preventDefault()
                    this.selectList(this.json[this.focusList])
                    this.hideList()
                    break;
                case ESC:
                    this.hideList()
                    break;
            }

            const listLength = this.json.length - 1;
            const outOfRangeBottom = this.focusList > listLength
            const outOfRangeTop = this.focusList < 0
            const topItemIndex = 0
            const bottomItemIndex = listLength

            let nextFocusList = this.focusList
            if (outOfRangeBottom) nextFocusList = topItemIndex
            if (outOfRangeTop) nextFocusList = bottomItemIndex
            this.focusList = nextFocusList
        },

        setValue(val) {
            this.type = val
        },



        /*==============================
          LIST EVENTS
        =============================*/

        handleDoubleClick(){
            this.json = [];
            this.getData("")
            // Callback Event
            let res = this.onShow ? this.onShow() : true;
            if (res) {
                this.showList()
            }
        },

        handleClick(){
            this.showList()
            this.getData(this.type)
        },

        handleBlur(e){
            // Callback Event
            this.onBlur ? this.onBlur(e) : null
            setTimeout(() => {
                // Callback Event
                let res = this.onHide ? this.onHide() : true;
                if (res) {
                    this.hideList()
                }
            },250);
        },

        handleFocus(e){
            this.focusList = 0;
            // Callback Event
            this.onFocus ? this.onFocus(e) : null
        },

        handlePaste(e){
            this.onPaste ? this.onPaste(e) : null;
        },

        mousemove(i){
            this.focusList = i;
        },

        activeClass(i){
            const focusClass = i === this.focusList ? 'focus-list' : ''
            return `${focusClass}`
        },

        hideList: function () {
            this.listActive = false;
        },
        showList: function () {
            this.listActive = true;
        },

        selectList(data){
            // Deep clone of the original object
            const clean = this.cleanUp(data);
            // Put the selected data to type (model)
            this.type = clean[this.anchor];
            // Hide List
            this.hideList();
            // Callback Event
            this.onSelect ? this.onSelect(clean) : null
        },

        deepValue(obj, path) {
            const arrayPath = path.split('.')
            for (var i = 0; i < arrayPath.length; i++) {
                obj = obj[arrayPath[i]];
            }
            return obj;
        },



        /*==============================
          AJAX EVENTS
        =============================*/

        composeParams(val) {
            const encode = (val) => this.encodeParams ? encodeURIComponent(val) : val
            let params = `${this.param}=${encode(val)}`
            if(this.customParams) {
                Object.keys(this.customParams).forEach((key) => {
                    params += `&${key}=${encode(this.customParams[key])}`
                })
            }
            return params
        },

        composeHeader(ajax) {
            if(this.customHeaders) {
                Object.keys(this.customHeaders).forEach((key) => {
                    ajax.setRequestHeader(key, this.customHeaders[key])
                })
            }
        },

        getData(value){
            if (value.length < this.min) {
                if (!value.length) {
                    this.json = [];
                }
                return;
            }
            this.manualGetData(value);
        },

        // Do Ajax Manually, so user can do whatever he want
        manualGetData(val) {
            const task = this.makeRequest(val)
            if (task && task.then) {
                return task.then((options) => {
                    this.json = options
                })
            }
        },

    },


    created(){
        // Sync parent model with initValue Props
        this.type = this.initValue ? this.initValue : null
    },

    mounted() {
    }

}
</script>
<style lang="scss">
$autocomplete-item-bg-color: #fcfcfc;
    .autocomplete-wrapper {
        .autocomplete-list {
            ul {
                list-style: none;
                padding: 0;

                li {
                    padding: 5px;
                    margin: 0;

                    &:nth-child(even) {
                        background: $autocomplete-item-bg-color;
                    }
                    &:nth-child(odd) {
                        background: darken($autocomplete-item-bg-color, 3);
                    }
                }
            }
        }
    }
</style>
